import React from 'react'
import classnames from 'classnames'

const generalFormFieldClassesThatAllFieldsNeed = {
  'formz-form-row': true
}

const FieldRowWrapper = ({ className, touched, error, children }) => {
  return (
    <div
      className={classnames({
        ...generalFormFieldClassesThatAllFieldsNeed,
        ...className,
        // override the 'formz-has-error' to be applied only when the field is touched before
        'formz-has-error': className['formz-has-error'] && touched // prevRule + touched
      })}>
      <div className="formz-form-element">{children}</div>
      <div className="formz-form-error">{touched && error}</div>
    </div>
  )
}

export default FieldRowWrapper



// WEBPACK FOOTER //
// ./src/components/common/FieldRowWrapper/FieldRowWrapper.js